module.exports = __webpack_public_path__ + "img/txt_hover.3486a174.svg";